import LoggedIn from "./LoggedIn";
import TeamOrMember from "./TeamOrMember";
import SignupMethod from "./SignupMethod";
import EmailForm from "./EmailForm";
import TeamLocation from "./TeamLocation";
import TeamSearch from "./TeamSearch";
import TeamEntry from "./TeamEntry";
import ConfirmDetails from "./ConfirmDetails";
import SignupComplete from "./SignupComplete";

export default [LoggedIn, TeamOrMember, SignupMethod, EmailForm, TeamLocation, TeamSearch, TeamEntry, ConfirmDetails, SignupComplete];
